<template>
    <v-card
        rounded="10"
        dark
        :color="color"
        width="100%"
        @click="$emit('click')"
    >
        <v-card-title v-if="descricaoProcessada">
            {{ descricaoProcessada }}
        </v-card-title>
        <v-card-text>
            {{ corpoProcessado }}
        </v-card-text>
        <v-card-actions>
            <v-spacer />
            <div class="text-caption">{{ caption }}</div>
        </v-card-actions>
    </v-card>
</template>
<script>
export default {
    name: "Mensagem",
    props: {
        msg: {
            type: Object,
            required: true,
        },
        caption: {
            type: String,
            required: false,
            default() {
                return "";
            }
        },
        color: {
            type: String,
            required: false,
            default() {
                return "primary";
            }
        }
    },
    computed: {
        descricaoProcessada() {
            return this.substituirVariaveis(this.msg.descricao, this.msg.campos_descricao);
        },
        corpoProcessado() {
            return this.substituirVariaveis(this.msg.corpo, this.msg.campos_corpo);
        }
    },
    methods: {
        substituirVariaveis(texto, campos) {
            if (!texto) return '';
            if (!campos) return texto;
            
            let resultado = texto;
            
            try {
                // Parse dos campos se for string JSON
                let parsedCampos = campos;
                if (typeof campos === 'string') {
                    try {
                        parsedCampos = JSON.parse(campos);
                    } catch (e) {
                        console.error('Erro ao fazer parse dos campos:', e);
                        return texto;
                    }
                }
                
                // Substituir cada variável {{1}}, {{2}}, etc.
                if (Array.isArray(parsedCampos) && parsedCampos.length > 0) {
                    parsedCampos.forEach(campo => {
                        if (campo.key && campo.value !== undefined) {
                            const key = campo.key; // "{{1}}"
                            const value = campo.value || '';
                            // Escapar caracteres especiais do regex
                            const keyEscaped = key.replace(/[{}]/g, '\\$&');
                            resultado = resultado.replace(new RegExp(keyEscaped, 'g'), value);
                        }
                    });
                }
            } catch (error) {
                console.error('Erro ao substituir variáveis:', error);
            }
            
            return resultado;
        }
    }
}
</script>
<style>
    
</style>